import ProjectsList from '../../components/Projects/ProjectsList';

const Projects = () => {
  return (
    <ProjectsList />
  );
};

export default Projects;
